import { Box, Grid, Stack } from '@mui/material';
import PageHeader from 'components/Header/Page';
import React, { useEffect, useState } from 'react';
import CustomAnalysisIcon from '../../assets/Custom Analysis & Recommendations.svg';
import SectorFilter from 'components/Dropdown/SectorFilter';
import CustomDropdown from 'components/Dropdown';
import NumberWidget from 'components/Widgets/NumberWidget';
import LoaderComponent from 'components/Loader';
import { fetchStarterWarehousesData, maxAutoTermData, customlastFetchData, longRunData, customConfigData, fetchSectorList } from 'service/service'
import moment from 'moment';
import { CustomizedDataGrid } from 'components/customized_data_grid';
import { useLocation, useNavigate } from 'react-router-dom';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import DBRComponent from './DBRComponent';
import UntaggedPieChart from './UntaggedPieChart';
import OverProvisionedPieChart from './OverProvisionedPieChart';
import { renderTooltipIcon } from '../TableauObs/common/KpiCard';
const regions = [
    'ALL',
    'Brazil South',
    'Australia East',
    'UK South',
    'South Central US',
    'East US',
    'Germany West Central'
];
const regionOptions = regions.map(location => ({ label: location, value: location }));
const sectorOptionsList = [
    'latam', 'apac', 'TBD', 'amesa', 'essa', 'flna', 'global', 'tbd', 'pbna', 'pfna', 'snt'
];
const envOptions = [
    { label: 'ALL', value: 'both' },
    { label: 'PROD', value: 'prod' },
    { label: 'PRE-PROD', value: 'preprod' },
    { label: 'QA', value: 'qa' },
    { label: 'Development', value: 'dev' },
    { label: 'Sandbox', value: 'sandbox' }
];


const CustomAnalysis = () => {
    const routerLocation = useLocation();
    const navigate = useNavigate();
    const {
        startDate: navStartDate,
        endDate: navEndDate,
        env: navEnv,
        sector: navSector,
        location: navLocation,
        selectedDateInString: navSelectedDate
    } = routerLocation.state || {};
    const [sectorName, setSectorName] = useState<string>(navSector || 'all');
    const [sector, setSector] = useState<string>(navSector || 'all');
    const [env, setEnv] = useState<string>(navEnv || 'prod');
    const [lastSync, setLastSync] = useState(null);
    const [location] = useState<string>(navLocation || 'South Central US');
    const [startDate] = useState<string>(navStartDate || moment().subtract(3, 'months').startOf('day').format('YYYY-MM-DD HH:mm'));
    const [endDate] = useState<string>(navEndDate || moment().format('YYYY-MM-DD HH:mm'));
    const [selectedDateInString] = useState<string>(navSelectedDate || '3M');
    const handleSectorChange = (value: string) => {
        setSector(value);
        // BUSINESS REQUIREMENT TO SEE ALL WHENEVER THE SECTOR IS CHANGED
        // setEnv('both');
    };
    const [configTable, setConfigTable] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // default from API
    const [paginationData, setPaginationData] = useState<{
        totalElements: number;
        totalPages: number;
    }>({
        totalElements: 0,
        totalPages: 0
    });
    const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
    const [sectorList, setSectorList] = useState<string[]>([]);
    const fetchSectors = async () => {
        const resp = await fetchSectorList({});
        if (resp?.success) {
            setSectorList(resp?.data || []);
        }
    };

    useEffect(() => {
        fetchSectors();
    }, []);

    const handleWidgetClick = () => {
        navigate('/databricksADB/long-running-jobs', {
            state: {
                startDate,
                endDate,
                env,
                sector: sectorName,
                location: location,
                selectedDateInString
            }
        });
    };

    const handleAutoTermWidgetClick = () => {
        navigate('/databricksADB/autoTerm', {
            state: {
                startDate,
                endDate,
                env,
                sector: sectorName,
                location: location,
                selectedDateInString
            }
        });
    };
    const handleStarterWarehouseWidgetClick = () => {
        navigate('/databricksADB/starterWarehouse', {
            state: {
                startDate,
                endDate,
                env,
                sector: sectorName,
                location: location,
                selectedDateInString
            }
        });
    };

    const [starterWarehouse, setStarterWarehouse] = useState<{ distinct_warehouse_count: number }[]>([]);
    const [maxAutoTerm, setMaxAutoTerm] = useState<{ _id: string | null; maxAutoTermMinutes: number }[]>([]);
    const [longRunning, setLongRunning] = useState<{ _id: string | null; longRunJobs: number }[]>([]);
    const [loader, setLoader] = useState({
        starterWarehouse: false,
        overProvisionedType: false,
        untaggedClusterType: false,
        autoTerminatonType: false,
        longRunningType: false,
        longRunningTableType: false,
        config: false
    });

    const fetchLastSync = async () => {
        const res = await customlastFetchData();
        if (res?.success && res?.statusCode === 200) {
            const date = res.data?.End_Time;
            setLastSync(date);
        }
    };

    const columnMapping: Record<string, string> = {
        workspace_name: 'Workspace',
        config: 'Config',
        config_type: 'Config Type',
        compute_type: 'Compute Type',
        cluster_count: 'Cluster Count',
    };

    const defaultColumns = ['Workspace', 'Config', 'Config Type', 'Compute Type', 'Cluster Count'];

    const generateFixedColumns = () => {
        return Object.entries(columnMapping).map(([key, displayName]) => ({
            key,
            name: displayName,
            width: 'auto',
        }));
    };

    const filterTableData = (data: any[]) => {
        return data.map((row) => {
            const filtered: Record<string, any> = {};
            Object.keys(columnMapping).forEach((key) => {
                filtered[key] = row[key];
            });
            return filtered;
        });
    };

    const formattedLastSync = lastSync
        ? (() => {
            const date = new Date(lastSync);
            const weekday = date.toLocaleString('en-US', { weekday: 'short', timeZone: 'UTC' });
            const day = date.toLocaleString('en-US', { day: '2-digit', timeZone: 'UTC' });
            const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
            const year = date.toLocaleString('en-US', { year: 'numeric', timeZone: 'UTC' });
            return `${weekday}, ${day} ${month} ${year}(UTC)`;
        })()
        : 'Loading...';
    const longRunDetailsFetch = async (params: { startDate: string; endDate: string; env: string; sector: string; location: string; selectedDateInString: string }) => {
        const { startDate, endDate, env, sector, location, selectedDateInString } = params;
        setLoader((prev) => ({
            ...prev,
            longRunningType: true
        }));

        const startFormatted = startDate.split(' ')[0];
        const endFormatted = endDate.split(' ')[0];

        const resp = await longRunData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
        if (resp?.success) {
            setLongRunning(resp?.data);
        }
        setLoader((prev) => ({
            ...prev,
            longRunningType: false
        }));
    };
    const starterWarehousesFetch = async (params: { startDate: string; endDate: string; env: string; sector: string; location: string; selectedDateInString: string }) => {
        const { startDate, endDate, env, sector, location, selectedDateInString } = params;
        setLoader((prev) => ({
            ...prev,
            starterWarehouse: true
        }));

        const startFormatted = startDate.split(' ')[0];
        const endFormatted = endDate.split(' ')[0];

        const resp = await fetchStarterWarehousesData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
        if (resp?.success) {
            setStarterWarehouse(resp?.data);
        }
        setLoader((prev) => ({
            ...prev,
            starterWarehouse: false
        }));
    };
    const autoTerminatonFetch = async (params: { startDate: string; endDate: string; env: string; sector: string; location: string; selectedDateInString: string }) => {
        const { startDate, endDate, env, sector, location, selectedDateInString } = params;
        setLoader((prev) => ({
            ...prev,
            autoTerminatonType: true
        }));

        const startFormatted = startDate.split(' ')[0];
        const endFormatted = endDate.split(' ')[0];

        const resp = await maxAutoTermData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
        if (resp?.success) {
            setMaxAutoTerm(resp?.data);
        }
        setLoader((prev) => ({
            ...prev,
            autoTerminatonType: false
        }));
    };

    const configData = async (params: {
        startDate: string;
        endDate: string;
        env: string;
        sector: string;
        location: string;
        selectedDateInString: string;
        page?: number;
        pageSize?: number;
        sortingInfo?: { sortBy: string; sortDir: string };
    }) => {
        const { startDate, endDate, env, sector, location, selectedDateInString, page, pageSize, sortingInfo } = params;
        setLoader((prev) => ({
            ...prev,
            config: true
        }));

        const { sortBy, sortDir } = sortingInfo ?? { sortBy: '', sortDir: '' };
        const startFormatted = startDate.split(' ')[0];
        const endFormatted = endDate.split(' ')[0];

        const resp = await customConfigData({
            startDate: startFormatted,
            endDate: endFormatted,
            env,
            sector,
            location,
            selectedDateInString,
            page,
            limit: pageSize,
            sortField: sortBy,
            sortOrder: sortDir
        });
        if (resp?.success) {
            const docs = resp.data?.docs ?? [];
            setConfigTable(filterTableData(docs));
            setColumns(generateFixedColumns());
            setPage(resp.data.page);
            setPageSize(resp.data.limit);
            setPaginationData({
                totalElements: resp.data.totalDocs,
                totalPages: resp.data.totalPages
            });
        }
        setLoader((prev) => ({
            ...prev,
            config: false
        }));
    };

    const handleExportRequest = async () => {
        const { sortBy, sortDir } = sortingInfo ?? { sortBy: '', sortDir: '' };
        const startFormatted = startDate.split(' ')[0];
        const endFormatted = endDate.split(' ')[0];

        const resp = await customConfigData({
            startDate: startFormatted,
            endDate: endFormatted,
            env,
            sector,
            location,
            selectedDateInString,
            page,
            limit: pageSize,
            sortField: sortBy,
            sortOrder: sortDir,
            exportType: 'excel'
        });

        if (resp?.success && resp?.data) {
            const { buffer, filename, contentType } = resp.data;
            if (buffer && buffer.data) {
                const byteArray = new Uint8Array(buffer.data);
                const blob = new Blob([byteArray], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        }
    };


    useEffect(() => {
        const params = { startDate, endDate, env, sector, location, selectedDateInString };
        starterWarehousesFetch(params);
        autoTerminatonFetch(params);
        longRunDetailsFetch(params);
        fetchLastSync();
    }, [startDate, endDate, env, sector, location, selectedDateInString]);

    useEffect(() => {
        configData({ startDate, endDate, env, sector, location, selectedDateInString, page, pageSize, sortingInfo });
    }, [startDate, endDate, env, sector, location, selectedDateInString, page, pageSize, sortingInfo])

    const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const handlePageSizeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setPageSize(Number(event.target.value));
        setPage(1);
    };

    const handleSorting = (sortingInfo: any) => {
        setSortingInfo(sortingInfo)
    };

    return (
        <Box sx={() => ({
            mt: { xs: '70px', sm: '60px', md: '80px' }
        })}>
            <PageHeader title="Custom Analysis & Recommendations" icon={CustomAnalysisIcon} lastSync={formattedLastSync}>
                {/* <CustomDropdown handleChange={(event) => setLocation(event.target.value)} value={location} options={regionOptions} /> */}
                <CustomDropdown
                    handleChange={(event) => {
                        const selected = event.target.value;
                        setEnv(selected);
                    }}
                    value={env}
                    options={envOptions ? envOptions : []}
                />

                <SectorFilter
                    sectorName={sectorName}
                    setSectorName={setSectorName}
                    sectorOptionsList={sectorList}
                    handleChange={handleSectorChange}
                />

            </PageHeader>
            <Grid container spacing={2} p={{ xs: 1, md: 2 }}>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Box sx={{ height: 187, cursor: 'pointer' }} onClick={handleStarterWarehouseWidgetClick}>
                                <NumberWidget
                                    title={<HighlightedText text="Starter Warehouses" />}
                                    tooltipLabel={`Count of Warehouses`}
                                    renderTooltip={(label) => renderTooltipIcon(label, 'light')}
                                    //hasTooltip={true}
                                    number={starterWarehouse[0]?.distinct_warehouse_count || 0}
                                    units=""
                                    isLoading={loader.starterWarehouse}
                                    bgColor='#ffffff'
                                    color='#000000'
                                    valueFontWeight={300}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box
                                sx={{
                                    height: 187, cursor: 'pointer'
                                }}
                                onClick={handleAutoTermWidgetClick}>

                                <NumberWidget
                                    title={<HighlightedText text="Auto Termination Clusters > 30 minutes" />}
                                    tooltipLabel={`Count of Clusters`}
                                    hasTooltip={true}
                                    number={`${maxAutoTerm[0]?.maxAutoTermMinutes ?? 0}`}
                                    units=""
                                    isLoading={loader.autoTerminatonType}
                                    bgColor='#ffffff'
                                    color='#000000'
                                    valueFontWeight={300}
                                    renderTooltip={(label) => renderTooltipIcon(label, 'light')}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ height: 187, cursor: 'pointer' }} onClick={handleWidgetClick}>
                                <NumberWidget
                                    title={<HighlightedText text="Long Running Jobs > 3 hrs" />}
                                    tooltipLabel={`Count of Jobs`}
                                    hasTooltip={true}
                                    number={`${longRunning[0]?.longRunJobs ?? 0}`}
                                    units=""
                                    isLoading={loader.longRunningType}
                                    bgColor='#ffffff'
                                    color='#000000'
                                    valueFontWeight={300}
                                    renderTooltip={(label) => renderTooltipIcon(label, 'light')}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Stack bgcolor="#ffffff" fontFamily="Montserrat" borderRadius="5px" padding={1}>
                        <OverProvisionedPieChart
                            startDate={startDate}
                            endDate={endDate}
                            env={env}
                            sector={sector}
                            location={location}
                            selectedDateInString={selectedDateInString}
                        />
                    </Stack>
                </Grid>
            </Grid>
            <Grid container spacing={2} p={{ xs: 1, md: 2 }} sx={{ mt: -2 }}>
                <Grid item xs={12} md={6}>
                    <Stack bgcolor="#ffffff" fontFamily="Montserrat" borderRadius="5px" padding={1}>
                        <Box sx={{ height: 400 }}>
                            {loader.untaggedClusterType ? (
                                <LoaderComponent size={50} />
                            ) : (

                                <UntaggedPieChart
                                    startDate={startDate}
                                    endDate={endDate}
                                    env={env}
                                    sector={sector}
                                    location={location}
                                    selectedDateInString={selectedDateInString}
                                />
                            )}
                        </Box>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Stack bgcolor="#fff" fontFamily="Montserrat" borderRadius="5px" padding={1}>
                        <DBRComponent
                            startDate={startDate}
                            endDate={endDate}
                            env={env}
                            sector={sector}
                            location={location}
                            selectedDateInString={selectedDateInString}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12} md={12}>
                    <CustomizedDataGrid
                        title="Top 50 Driver and Worker Configuration"
                        tableColumns={columns}
                        tableData={configTable}
                        tableType="incident-details-ver"
                        defaultColumnNames={defaultColumns}
                        onSorting={handleSorting}
                        isSortIcon={true}
                        currSorting={sortingInfo}
                        page={page}
                        pageSize={pageSize}
                        paginationData={paginationData}
                        listLength={configTable.length}
                        handlepageSizeChange={handlePageSizeChange}
                        handlePageChange={handlePageChange}
                        isDateRangeFilter={false}
                        isDisabled={false}
                        isFetching={loader.config}
                        showExport={true}
                        exportTableData={handleExportRequest}
                    />
                </Grid>
            </Grid>
        </Box >
    );
};

export default CustomAnalysis;
